import { routes } from "@/routes/utils";

export const tabs = [
  { title: "Project Info.", value: routes.projectInfo },
  { title: "Team Assignment", value: routes.teamAssignment },
  { title: "Project Design Doc", value: routes.projectDocDesign },
  { title: "Project Plan", value: routes.projectPlan },
];
